import * as React from "react";
// autoComplete 增强组件 | 高阶组件

// 限制输入过长的文字 当前限制为30字符
export default function autoCompleteEnhance(WrappedComponent) {
  return class extends React.Component<any, any> {
    onChange = e => {
      const { onChange } = this.props;
      if (onChange) {
        onChange(e && e.substr(0, 30));
      }
    };

    render() {
      // Wraps the input component in a container, without mutating it. Good!
      return <WrappedComponent {...this.props} onChange={this.onChange} />;
    }
  };
}
